import React from 'react';
import './PageLoader.scss';

// Dyskretny wskaźnik ładowania w miejscu treści strony (menu i stopka zostają).
// Pojawia się z opóźnieniem w CSS, więc przy szybkim przejściu między stronami nic nie miga.
export default function PageLoader({ label = 'Ładowanie…' }) {
    return (
        <section className='pageLoader' role='status' aria-live='polite'>
            <span className='pageLoader_spinner' aria-hidden='true' />
            <span className='pageLoader_label'>{label}</span>
        </section>
    );
}
